//#region src/instrumentations/registerInitial.ts
function registerInitialInstrumentations(faro) {
	faro.instrumentations.add(...faro.config.instrumentations);
}
//#endregion
export { registerInitialInstrumentations };

//# sourceMappingURL=registerInitial.js.map